var $ = require('../internals/export');
var log1p = require('../internals/math-log1p');

// `Math.log1p` method
// https://tc39.github.io/ecma262/#sec-math.log1p
$({ target: 'Math', stat: true }, { log1p: log1p });



//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/modules/es.math.log1p.js
// module id = 602
// module chunks = 20 21 22 23 24 25 26 27 28 29 30 31 32 33